var map = {
	"./badrutts-palace.jpg": [
		124,
		0
	],
	"./chasa-montana.jpg": [
		125,
		1
	],
	"./chesa-randolina.jpg": [
		126,
		12
	],
	"./gstaad-palace.jpg": [
		127,
		23
	],
	"./guarda-val.jpg": [
		128,
		24
	],
	"./hornberg.jpg": [
		129,
		25
	],
	"./hotel-ameron.jpg": [
		130,
		26
	],
	"./hotel-belvedere.jpg": [
		131,
		27
	],
	"./hotel-bernerhof.jpg": [
		132,
		28
	],
	"./hotel-de-rougemont.jpg": [
		133,
		29
	],
	"./hotel-jungfrau.jpg": [
		134,
		2
	],
	"./hotel-kernen.jpg": [
		135,
		3
	],
	"./hotel-krone.jpg": [
		136,
		4
	],
	"./hotel-kulm.jpg": [
		137,
		5
	],
	"./hotel-resort-riffelalp.jpg": [
		138,
		6
	],
	"./hotel-schweizerhof.jpg": [
		139,
		7
	],
	"./hotel-spitzhorn.jpg": [
		140,
		8
	],
	"./hotel-tschuggen.jpg": [
		141,
		9
	],
	"./hotel-ultima.jpg": [
		142,
		10
	],
	"./hotel-valsana.jpg": [
		143,
		11
	],
	"./hotel-victoria.jpg": [
		144,
		13
	],
	"./hotel-waldhaus-am-see.jpg": [
		145,
		14
	],
	"./hotel-zurbriggen.jpg": [
		146,
		15
	],
	"./le-grand-bellevue.jpg": [
		147,
		16
	],
	"./lenkerhof.jpg": [
		148,
		17
	],
	"./rock-resort.jpg": [
		149,
		18
	],
	"./sporthotel-pontresina.jpg": [
		150,
		19
	],
	"./suvretta-house.jpg": [
		151,
		20
	],
	"./the-chedi.jpg": [
		152,
		21
	],
	"./waldhotel-national-arosa.jpg": [
		153,
		22
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 64;
module.exports = webpackAsyncContext;